import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      paddingLeft: theme.spacing(4),
      '& > h2:first-child': {
        marginTop: theme.spacing(1)
      }
    }
  }
}));

const VerticalTabPanel = (props) => {
  const { children, currentTab, tab, ...other } = props;
  const classes = useStyles();

  if (currentTab !== tab) {
    return null;
  }

  return (
    <div
      className={classes.wrapper}
      role="tabpanel"
      id={`vertical-tabpanel-${tab}`}
      aria-labelledby={`vertical-tab-${tab}`}
      {...other}
    >
      {children}
    </div>
  );
}

VerticalTabPanel.propTypes = {
  children: PropTypes.node,
  tab: PropTypes.any.isRequired,
  currentTab: PropTypes.any.isRequired,
};

export default VerticalTabPanel;
